export default __webpack_public_path__ + "static/media/667.06f3c44e.png";